/* tslint:disable:component-selector */
import {Component, Input} from '@angular/core';

@Component({
  selector: 'data-card',
  templateUrl: './data-card.component.html',
  styleUrls: ['./data-card.component.scss']
})
export class DataCardComponent {

  @Input() mainTitle: string;
  @Input() secondaryTitle: string;
  @Input() cumulativeData: number;
  @Input() todayCumulativeData: number;
  @Input() perMillionCumulativeData: number;
  @Input() isPercentage = false;
  @Input() cardTextColor: string;
  @Input() isRotatable: boolean;

}
